// extracted by mini-css-extract-plugin
export var excerpt = "school-preview-module--excerpt--XBnWE";
export var leadMediaThumb = "school-preview-module--leadMediaThumb--YjTox";
export var root = "school-preview-module--root--dB74y";
export var title = "school-preview-module--title--PvKlu";